import React from "react";
import {
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import FacebookIcon from "../../assets/images/icons/Facebook-Logo.svg";
import Ic_WhatsApp from "../../assets/images/icons/Ic_WhatsApp.svg";
import XIcon from "../../assets/images/icons/Ic_X.svg";
import CopyIcon from "../../assets/images/icons/Ic_Copy.svg";
import { copyToClipboard } from "../../utils/utils";
import { useToast } from "../../Services/ToastContext";
import { useTranslation } from "react-i18next";
import Modal from "../Common/Modal";

const ShareLinkComponent: React.FC<{
  shareLink: string;
  open: boolean;
  onClose: () => void;
  title?: string;
}> = ({ shareLink, open, onClose, title }) => {
  const shareButtonClass = "!bg-Gray !px-8 !py-6 rounded-md";
  const { showToast } = useToast();

  const {t} = useTranslation()
  return (
    <Modal isOpen={open} onClose={onClose} header={title ?? t("share_profile")}>
      <div className="flex gap-2">
        <FacebookShareButton className={shareButtonClass} url={shareLink}>
          <img className="h-6 w-6" alt="" src={FacebookIcon} />
        </FacebookShareButton>
        <TwitterShareButton className={shareButtonClass} url={shareLink}>
          <img src={XIcon} className="h-6 w-6" alt="" />
        </TwitterShareButton>
        <WhatsappShareButton className={shareButtonClass} url={shareLink}>
          <img src={Ic_WhatsApp} className="h-6 w-6" alt="" />
        </WhatsappShareButton>
        <TelegramShareButton className={shareButtonClass} url={shareLink}>
          <TelegramIcon className="h-6 w-6" />
        </TelegramShareButton>
      </div>
      <div
        className="flex cursor-pointer items-center gap-4"
        onClick={() => {
          copyToClipboard(shareLink, showToast);
        }}
      >
        <img src={CopyIcon} className="h-5 w-5" alt="" />
        <div className="text-secondaryDark">{t("copy_link")}</div>
      </div>
    </Modal>
  );
};

export default ShareLinkComponent;
